import { render, staticRenderFns } from "./SupportJoinTeamModal.vue?vue&type=template&id=61756b7a&scoped=true&"
import script from "./SupportJoinTeamModal.vue?vue&type=script&lang=js&"
export * from "./SupportJoinTeamModal.vue?vue&type=script&lang=js&"
import style0 from "./SupportJoinTeamModal.vue?vue&type=style&index=0&id=61756b7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61756b7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61756b7a')) {
      api.createRecord('61756b7a', component.options)
    } else {
      api.reload('61756b7a', component.options)
    }
    module.hot.accept("./SupportJoinTeamModal.vue?vue&type=template&id=61756b7a&scoped=true&", function () {
      api.rerender('61756b7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Dashboard/Layout/Modals/SupportJoinTeamModal.vue"
export default component.exports